/** Download a credentialed response without exposing its blob URL to callers. */
export async function downloadFile(
  url: string,
  filename: string,
  headers: Record<string, string> = {},
): Promise<void> {
  const response = await fetch(url, { method: 'GET', credentials: 'include', headers })
  if (!response.ok) throw new Error(`Download failed (${response.status})`)

  const blob = await response.blob()
  const objectUrl = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = objectUrl
  anchor.download = filename
  document.body.appendChild(anchor)
  try {
    anchor.click()
  } finally {
    anchor.remove()
    URL.revokeObjectURL(objectUrl)
  }
}
